import httpClient from '@/lib/httpClient.js'
import { useQuery } from '@tanstack/react-query'

export default function useGetExpenseCategories() {
  const fetchData = async () => {
    const response = await httpClient.get('/team/transaction-category/expenses')
    return response.data.data
  }

  return useQuery({
    queryKey: ['transaction-categories', { type: 'expenses' }],
    queryFn: fetchData,
    // enabled: isAuthenticated,
  })
}
